import React from 'react';
import "./checkout.styles.scss";

import { connect as connectRedux } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectCartItems, selectCartTotalPrice } from '../../redux/cart/cart.selectors';
import CheckoutItem from '../../components/checkout-item/checkout-item.component';

const Checkout = ( { cartItems, totalPrice } ) => (
    <div className="checkout-page">
        <div className="checkout-header">
            <div className="header-block">
                <span>Product</span>
            </div>
            <div className="header-block">
                <span>Description</span>
            </div>
            <div className="header-block">
                <span>Quantity</span>
            </div>
            <div className="header-block">
                <span>Price</span>
            </div>
            <div className="header-block">
                <span>Remove</span>
            </div>
        </div>
        {
            cartItems.map( cartItem =>
                <CheckoutItem key={ cartItem.id } cartItem={ cartItem } />
            )
        }
        <div className="total">
            <span>TOTAL: ${ totalPrice } </span>
        </div>
    </div>
);

const mapPropsToState = createStructuredSelector( {
    cartItems: selectCartItems,
    totalPrice: selectCartTotalPrice
} );

export default connectRedux( mapPropsToState )( Checkout );